<template>
  <el-card class="box-card"  v-loading.fullscreen.lock="loading"   element-loading-text="努力上传中">
    <el-steps :active="active" align-center process-status="finish">
      <el-step title="基础信息"></el-step>
      <el-step title="商家信息"></el-step>
      <el-step title="提交资料"></el-step>
    </el-steps>

    <div class="card-contetn">
      <el-form
        v-if="active == 0"
        :model="dataForm1"
        status-icon
        :rules="rules"
        ref="dataForm1"
        label-width="140px"
        class="demo-ruleForm"
        style="width: 500px; margin: 30px auto"
      >
        <el-form-item label="登录账户" prop="username">
          <el-input
            type="type"
            v-model="dataForm1.username"
            placeholder="请输入登录账户"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input
            type="password"
            v-model="dataForm1.password"
            placeholder="请输入登录密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input
            type="password"
            v-model="dataForm1.password2"
            placeholder="请输入确认密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="dataForm1.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input
            v-model="dataForm1.realName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="dataForm1.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </el-form>

      <el-form
        v-if="active == 1"
        :model="dataForm2"
        status-icon
        :rules="rules"
        ref="dataForm2"
        label-width="150px"
        class="demo-ruleForm"
        style="width: 1400px; margin: 30px auto"
      >
        <h3>基础信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item label="姓名" prop="legalRealName">
              <el-input
                v-model="dataForm2.legalRealName"
                placeholder="请输入姓名"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="商家名称" prop="welfareMerchantName">
              <el-input
                v-model="dataForm2.welfareMerchantName"
                placeholder="请输入商家名称"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="身份证号" prop="legalIdCardNumber">
              <el-input
                v-model="dataForm2.legalIdCardNumber"
                placeholder="请输入身份证号"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="手机号" prop="legalMobilePhone">
              <el-input
                v-model="dataForm2.legalMobilePhone"
                placeholder="请输入手机号"
                autocomplete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="商家类型" prop="welfareMerchantType">
            <el-select
              v-model="dataForm2.welfareMerchantType"
              placeholder="请选择"
              style="width: 440px"
            >
              <el-option
                :label="x.label"
                :value="x.value"
                v-for="x in options2"
                :key="x.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <!-- 账户信息 -->
        <h3>账户信息</h3>
        <!-- <el-row>
          <el-col :span="10">
            <el-form-item label="是否作为代收账户" prop="isCollectionAccount">
              <el-select
                v-model="dataForm2.isCollectionAccount"
                placeholder="请选择"
                style="width: 434px"
              >
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14"
            >(注：如果该账户作为代收账户,则在是否作为代收账户中选择是)</el-col
          >
        </el-row> -->
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户人" prop="accountName">
              <el-input
                type="type"
                v-model="dataForm2.accountName"
                placeholder="请输入开户人"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户" prop="accountBankNumber">
              <el-input
                v-model="dataForm2.accountBankNumber"
                placeholder="请输入银行账户"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户行" prop="accountBankName">
              <el-input
                type="type"
                v-model="dataForm2.accountBankName"
                placeholder="请输入开户行"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item label="返点值" prop="rebate">
              <el-input
                v-model="dataForm2.rebate"
                autocomplete="off"
                placeholder="请输入0-1之间的小数，最多三位小数"
              ></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="付款账期(天)" prop="accountPeriod">
              <el-input
                type="type"
                v-model="dataForm2.accountPeriod"
                placeholder="请输入付款账期"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="机构号" prop="companyNo">
              <el-input
                type="number"
                v-model.trim="dataForm2.companyNo"
                placeholder="请输入机构号"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 后面新增 -->
        <el-row>
          <el-col :span="10">
            <el-form-item label="节点号" prop="nodeNo">
              <el-input
                type="number"
                v-model.trim="dataForm2.nodeNo"
                placeholder="请输入节点号"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开户银行行号" prop="openBankNumber">
              <el-input
                type="type"
                v-model="dataForm2.openBankNumber"
                placeholder="请输入开户银行行号"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="费项" prop="bizId">
              <el-input
                type="number"
                v-model.trim="dataForm2.bizId"
                placeholder="请输入费项"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="操作类型：" prop="operateType">
            <el-select
              v-model="dataForm2.operateType"
              placeholder="请选择"
              :disabled="true"
              style="width: 435px"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value * 1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <!-- <el-row>
          <el-col :span="10">
            <el-form-item label="微信账号" prop="accountWeiXinNumber">
              <el-input type="type" v-model="dataForm2.accountWeiXinNumber" placeholder="请输入微信账号" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="支付宝账号" prop="accountPayBaoNumber">
              <el-input v-model="dataForm2.accountPayBaoNumber" placeholder="请输入支付宝账号" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
      </el-form>

      <el-form
        v-if="active == 1 && dataForm2.welfareMerchantType == 2"
        :model="chantTypeForm"
        status-icon
        :rules="chantTypeFormRules"
        ref="chantTypeForm"
        label-width="150px"
        class="demo-ruleForm"
        style="width: 1400px; margin: 30px auto"
      >
        <h3>商家信息</h3>
        <el-row>
          <!-- <el-col :span="10">
            <el-form-item label="商家名称" prop="welfareMerchantName">
              <el-input
                type="type"
                v-model="dataForm2.welfareMerchantName"
                placeholder="请输入商家名称"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input
                type="text"
                v-model="chantTypeForm.enterpriseName"
                placeholder="请输入企业名称"
                autocomplete="off"
                maxlength="40"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="企业性质" prop="enterpriseNature">
              <el-select
                v-model="chantTypeForm.enterpriseNature"
                placeholder="请选择"
                style="width: 440px"
              >
                <el-option label="私营" :value="1"></el-option>
                <el-option label="国企" :value="2"></el-option>
                <el-option label="个体工商" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="企业电话" prop="enterprisePhone">
              <el-input
                v-model="chantTypeForm.enterprisePhone"
                placeholder="请输入企业电话"
                autocomplete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10" style="display: flex">
            <el-form-item label="企业省份" prop="enterpriseRegionProvince">
              <el-select
                v-model="chantTypeForm.enterpriseRegionProvince"
                placeholder="请选择"
                @change="city"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="市"
              prop="enterpriseRegionCity"
              label-width="40px"
            >
              <el-select
                v-model="chantTypeForm.enterpriseRegionCity"
                placeholder="请选择"
                @change="district"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区" prop="enterpriseRegion" label-width="40px">
              <el-select
                v-model="chantTypeForm.enterpriseRegion"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in districtList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="详细地址" prop="enterpriseAddress">
              <el-input
                type="text"
                v-model="chantTypeForm.enterpriseAddress"
                placeholder="请输入详细地址"
                autocomplete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 
        <el-row>
          <el-col :span="10">
            <el-form-item label="企业网址" >
              <el-input
               type="text"
                v-model="dataForm2.enterpriseWebSite"
                placeholder="请输入企业网址"
                autocomplete="off"
                 maxlength="40"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <h3>执照信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item label="营业类型" prop="businessScope">
              <el-input
                type="text"
                v-model="chantTypeForm.businessScope"
                placeholder="请输入营业类型"
                autocomplete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="社会统一信用代码"
              prop="businessRegistrationNo"
            >
              <el-input
                type="text"
                v-model="chantTypeForm.businessRegistrationNo"
                placeholder="请输入社会统一信用代码"
                autocomplete="off"
                maxlength="18"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="成立日期" prop="establishmentDate">
              <el-date-picker
                v-model="chantTypeForm.establishmentDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd hh:mm:ss"
                style="width: 435px"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="雇员人数" prop="employeesNumber">
              <el-input
                v-model="chantTypeForm.employeesNumber"
                placeholder="请输入雇员人数"
                autocomplete="off"
                maxlength="7"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <h3>证件信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item label="法人身份证正面上传">
              <!-- <Upload :imgUrl="dataForm2.idCardPicFrontList" ></Upload> -->
              <img-upload
                :imgUrl="
                  chantTypeForm.idCardPicFrontUrlList &&
                  chantTypeForm.idCardPicFrontUrlList[0]
                "
                @setNewUrl="getImg1"
                @getLoading="getLoading"
              ></img-upload>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="法人身份证反面上传">
              <img-upload
                :imgUrl="
                  chantTypeForm.idCardPicBackUrlList &&
                  chantTypeForm.idCardPicBackUrlList[0]
                "
                @getLoading="getLoading"
                @setNewUrl="getImg2"
              ></img-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="营业执照上传">
              <img-upload
                :imgUrl="
                  chantTypeForm.businessLicensePicUrlList &&
                  chantTypeForm.businessLicensePicUrlList[0]
                "
                @getLoading="getLoading"
                @setNewUrl="getImg3"
              ></img-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-form
        v-if="active == 1 && dataForm2.isCollectionAccount == 1"
        :model="clearForm"
        status-icon
        :rules="clearFormRules"
        ref="clearForm"
        label-width="140px"
        class="demo-ruleForm"
        style="width: 1400px; margin: 30px auto"
      >
        <h3>清算账户信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户人" prop="accountName">
              <el-input
                type="type"
                v-model="clearForm.accountName"
                placeholder="请输入开户人"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户" prop="accountBankNumber">
              <el-input
                v-model="clearForm.accountBankNumber"
                placeholder="请输入银行账户"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户行" prop="accountBankName">
              <el-input
                type="type"
                v-model="clearForm.accountBankName"
                placeholder="请输入开户行"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="返点值" prop="rebate">
              <el-input
                v-model="clearForm.rebate"
                autocomplete="off"
                placeholder="请输入0-1之间的小数，最多三位小数"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        v-if="active == 1 && dataForm2.isCollectionAccount == 1"
        :model="paymentForm"
        status-icon
        :rules="paymentFormRules"
        ref="paymentForm"
        label-width="140px"
        class="demo-ruleForm"
        style="width: 1400px; margin: 30px auto"
      >
        <h3>付款信息</h3>

        <el-row>
          <el-col :span="10">
            <el-form-item label="开户人" prop="accountName">
              <el-input
                type="type"
                v-model="paymentForm.accountName"
                placeholder="请输入开户人"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户" prop="accountBankNumber">
              <el-input
                v-model="paymentForm.accountBankNumber"
                placeholder="请输入银行账户"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户行" prop="accountBankName">
              <el-input
                type="type"
                v-model="paymentForm.accountBankName"
                placeholder="请输入开户行"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
             <el-col :span="10">
            <el-form-item label="机构号" prop="companyNo">
              <el-input
                type="number"
                v-model.trim="paymentForm.companyNo"
                placeholder="请输入机构号"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>

      
        <!-- 后面新增 -->
        <el-row>
          <el-col :span="10">
            <el-form-item label="节点号" prop="nodeNo">
              <el-input
                type="number"
                v-model.trim="paymentForm.nodeNo"
                placeholder="请输入节点号"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开户银行行号" prop="openBankNumber">
              <el-input
                type="type"
                v-model="paymentForm.openBankNumber"
                placeholder="请输入开户银行行号"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="费项" prop="bizId">
              <el-input
                type="number"
                v-model.trim="paymentForm.bizId"
                placeholder="请输入费项"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="操作类型：" prop="operateType">
            <el-select
              v-model="paymentForm.operateType"
              placeholder="请选择"
              :disabled="true"
              style="width: 435px"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value * 1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
          <el-row>
          <el-col :span="10">
           
      <el-form-item label="协议号：" prop="payAgreementNumber" v-if="paymentForm.operateType==2">
        <el-input type="number" placeholder="请输入协议号" v-model.trim="paymentForm.payAgreementNumber"></el-input>
      </el-form-item>
          </el-col>

       
        </el-row>

      </el-form>
      <div v-if="active == 2 && info.tanantState == 1" class="submitCheck">
        <i class="el-icon-success icon-style"></i>
        <h3>资料提交成功</h3>
        <p>请等待审核通知！</p>
      </div>
      <div v-else-if="active == 2 && info.tanantState == 3" class="submitCheck">
        <i class="el-icon-error icon-style" style="color: red"></i>
        <h3>审核失败，请修改资料重新提交！</h3>
        <p>{{ info.tanantRemark }}</p>
      </div>

      <div class="stepBtn" v-if="active != 2">
        <el-button @click="prevStep" v-if="active != 0">上一步</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div>
      <div class="stepBtn check" v-else>
        <el-button @click="backHandle">返回</el-button>
        <el-button type="primary" @click="seeInfoHandle">{{
          info.tanantState == 1 ? "查看资料" : "修改资料"
        }}</el-button>
      </div>
    </div>
  </el-card>
</template>
<script>
import reg from "@/utils/regular.js";
// import debounce from "lodash/debounce";
import ImgUpload from "@/components/img-upload";
// import { delete } from 'vue/types/umd';
export default {
  name: "enterpriseBusiness",
  components: {
    ImgUpload,
  },
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      }
      if (!reg.phone.test(value)) {
        callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    let checkIdNumber = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入身份证号"));
      }
      if (!reg.idNumber.test(value)) {
        callback(new Error("请输入正确的身份证号"));
      }
      callback();
    };

    let checkuser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户"));
      }
      if (!reg.userreg.test(value)) {
        callback(new Error("账号为6-18位任意组合"));
      }
      callback();
    };

    let checkPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户密码"));
      }
      if (!reg.pwdreg.test(value)) {
        callback(new Error("密码为6-18位数字或字母组合"));
      }
      callback();
    };

    let checkEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱"));
      }
      if (!reg.email.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      }
      callback();
    };

    let checkZheng = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入数字"));
      }
      if (!reg.isZheng.test(value)) {
        callback(new Error("请输入整数"));
      }
      callback();
    };

    let checkXiao = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入数字"));
      }

      if (!reg.isPercent.test(value)) {
        callback(new Error("请输入0-1之间的小数,最多三位小数"));
      }
      callback();
    };

    var validateComfirmPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("确认密码不能为空"));
      } else if (value !== this.dataForm1.password) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };

    return {
      password2: "",
      actions: "",
      loading1: false,
      loading2: false,
      // idCardPicFrontUrlList:[],
      // idCardPicBackUrlList:[],
      // businessLicensePicUrlList:[],
      approveId: "",
      infoId: "",
      tenantInformationId: "",
      info: {},
      imgurl1: [],
      loading: false,
      options: [
        {
          value: 1,
          label: "私营",
        },
        {
          value: 2,
          label: "国企",
        },
        {
          value: 3,
          label: "个体工商",
        },
      ],
      options2: [
        {
          value: 1,
          label: "个人",
        },
        {
          value: 2,
          label: "企业",
        },
      ],
      options3: [
        { label: "批量代付", value: 1 },
        { label: "实时付款", value: 2 },
        { label: "批量代收", value: 3 },
        { label: "实时收款", value: 4 },
      ],
      rules: {
        username: [{ required: true, validator: checkuser, trigger: "blur" }],
        password: [{ required: true, validator: checkPwd, trigger: "blur" }],
        password2: [
          {
            required: true,
            validator: validateComfirmPassword,
            trigger: "blur",
          },
        ],
        mobile: [{ required: true, validator: checkPhone, trigger: "blur" }],
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [{ required: true, validator: checkEmail, trigger: "blur" }],
        legalRealName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        legalIdCardNumber: [
          { required: true, validator: checkIdNumber, trigger: "blur" },
        ],
        legalMobilePhone: [
          { required: true, validator: checkPhone, trigger: "blur" },
        ],
        welfareMerchantType: [{ required: true, message: "请选择企业类型" }],

        isCollectionAccount: [
          { required: true, message: "请选择是否代收账户", trigger: "change" },
        ],

        welfareMerchantName: [
          { required: true, message: "请输入商家名称", trigger: "blur" },
        ],
        // enterpriseWebSite: [
        //   { required: true, message: "请输入企业网址", trigger: "blur" },
        // ],

        rebate: [{ required: true, validator: checkXiao, trigger: "blur" }],

        accountName: [
          { required: true, message: "请输入开户名", trigger: "blur" },
        ],
        accountBankName: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        accountBankNumber: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
        accountWeiXinNumber: [
          { required: true, message: "请输入微信账号", trigger: "blur" },
        ],
        accountPayBaoNumber: [
          { required: true, message: "请输入支付宝账号", trigger: "blur" },
        ],
        // 后面添加的
        companyNo: [
          { required: true, message: "请输入机构号", trigger: "blur" },
        ],
        nodeNo: [{ required: true, message: "请输入节点号", trigger: "blur" }],
        openBankNumber: [
          { required: true, message: "请输入开户银行行号", trigger: "blur" },
        ],
        bizId: [{ required: true, message: "请输入费项", trigger: "blur" }],
        accountPeriod: [
          { required: true, validator: checkZheng, trigger: "blur" },
        ],
      },

      chantTypeFormRules: {
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        enterpriseNature: [
          { required: true, message: "请输入企业性质", trigger: "blur" },
        ],
        enterprisePhone: [
          { required: true, message: "请输入企业电话", trigger: "blur" },
        ],
        enterpriseAddress: [
          { required: true, message: "请输入企业详细地址", trigger: "blur" },
        ],
        businessScope: [
          { required: true, message: "请输入企业类型", trigger: "blur" },
        ],
        businessRegistrationNo: [
          {
            required: true,
            message: "请输入社会统一信用代码",
            trigger: "blur",
          },
        ],
        establishmentDate: [
          { required: true, message: "请输入成立日期", trigger: "blur" },
        ],
        employeesNumber: [
          { required: true, validator: checkZheng, trigger: "blur" },
        ],

        idCardPicFrontList: [
          { required: true, message: "请上传身份证照片", trigger: "change" },
        ],
        idCardPicBackList: [
          { required: true, message: "请上传身份证照片", trigger: "change" },
        ],
        businessLicensePicList: [
          { required: true, message: "请上传营业执照照片", trigger: "change" },
        ],
        enterpriseRegionProvince: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],

        enterpriseRegionCity: [
          { required: true, message: "请选择市", trigger: "change" },
        ],
        enterpriseRegion: [
          { required: true, message: "请选择区", trigger: "change" },
        ],
      },

      clearFormRules: {
        rebate: [{ required: true, validator: checkXiao, trigger: "blur" }],

        accountName: [
          { required: true, message: "请输入开户名", trigger: "blur" },
        ],
        accountBankName: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        accountBankNumber: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
      },
      paymentFormRules: {
        rebate: [{ required: true, validator: checkXiao, trigger: "blur" }],
        accountBankName: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        accountBankNumber: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
        accountName: [
          { required: true, message: "请输入开户名", trigger: "blur" },
        ],
        companyNo: [
          { required: true, message: "请输入机构号", trigger: "blur" },
        ],
        nodeNo: [{ required: true, message: "请输入节点号", trigger: "blur" }],
        openBankNumber: [
          { required: true, message: "请输入开户银行行号", trigger: "blur" },
        ],
        bizId: [{ required: true, message: "请输入费项", trigger: "blur" }],
        accountPeriod: [
          { required: true, validator: checkZheng, trigger: "blur" },
        ],
         payAgreementNumber: [
          { required: true, message: '请输入协议号', trigger: "blur" },
        ],
        
      },
      dataForm1: {
        tenantCode: 666666,
        username: "",
        password: "",
        mobile: "",
        realName: "",
        email: "",
        id: "",
      },
      businessLicense: "",
      logoPositon: "",
      dataForm2: {
        id: "",
        legalRealName: "",
        legalIdCardNumber: "",
        legalMobilePhone: "",
        welfareMerchantType: null,
        isCollectionAccount: 2,
        tenantInformationId: "",
        accountPeriod: "",
        accountName: "",
        accountBankName: "",
        accountBankNumber: "",
        rebate: 0,
        // accountWeiXinNumber: "",
        // accountPayBaoNumber: "",
        tenantCode: 666666,

        companyNo: "",
        nodeNo: "",
        openBankNumber: "",
        bizId: "",
        payAgreementNumber: "",
        operateType: 4,
      },
      chantTypeForm: {
        enterpriseName: "",
        enterpriseNature: "",
        enterprisePhone: "",
        enterpriseAddress: "",
        enterpriseRegionProvince: "",
        enterpriseRegionCity: "",
        enterpriseRegion: "",
        businessScope: "",
        businessRegistrationNo: "",
        establishmentDate: "",
        employeesNumber: "",
        idCardPicFrontList: [],
        idCardPicBackList: [],
        businessLicensePicList: [],
      },
      clearForm: {
        accountName: "",
        accountBankName: "",
        accountBankNumber: "",
        rebate: 0,
      },
      paymentForm: {
        rebate: 0,
        accountBankName: "",
        accountBankNumber: "",
        accountName: "",
        companyNo: "",
        nodeNo: "",
        openBankNumber: "",
        bizId: "",
        operateType: 2,
        accountPeriod: "",
        payAgreementNumber:""
      },
      isEdit: true,
      active: 0,
      imageUrl1: "",
      imageUrl2: "",
      imageUrl3: "",
      flag: false,
      provinceList: [],
      cityList: [],
      districtList: [],
    };
  },
  watch: {
    isEdit() {
      this.$refs.dataForm3.clearValidate();
    },
    $route(to) {
      this.approveId = to.query.approveId;
      if (this.active == 0)
        this.getBaseInfo(
          sessionStorage.getItem("tenantInformationId") || this.approveId
        );
    },
  },
  // activated() {
  //   this.getInfo();
  // },
  created() {
    this.province();
    if (this.$route.query.record) {
      this.active = this.$route.query.record * 1;
      this.approveId = this.$route.query.approveId;
    }
    if (this.active >= 2) this.isCheck();
    else if (this.active == 0 && sessionStorage.getItem("tenantInformationId"))
      this.getBaseInfo(sessionStorage.getItem("tenantInformationId"));
  },
  methods: {
    // 获取省份
    province() {
      // eslint-disable-line no-unused-vars
      this.$request
        .post("/approver-api/api/wemp/region/list", {
          treeLevel: 1,
          pid: 0,
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            return this.$message.error(res.msg);
          }

          this.provinceList = res.data;
        });
    },
    city() {
      this.pid = this.chantTypeForm.enterpriseRegionProvince;
      
      this.$request
        .post("/approver-api/api/wemp/region/list", {
          treeLevel: 2,
          pid: this.chantTypeForm.enterpriseRegionProvince,
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            return this.$message.error(res.msg);
          }

          this.cityList = res.data;
        });
    },
    district() {

      
      this.$request
        .post("/approver-api/api/wemp/region/list", {
          treeLevel: 3,
          pid: this.chantTypeForm.enterpriseRegionCity,
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            return this.$message.error(res.msg);
          }

          this.districtList = res.data;
        });
    },
    //审批
    isCheck() {
      this.$request
        .post("/approver-api/api/web/approvetenantinformation/check")
        .then((res) => {
          console.log(res);
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.info = res.data;
          if (res.data.approveRecordList.length > 0) {
            sessionStorage.setItem(
              "tenantInformationId",
              res.data.approveRecordList[0].approveId
            );
            if (res.data.approveRecordList[1]) {
              sessionStorage.setItem(
                "enterpriseAccountId",
                res.data.approveRecordList[1].approveId
              );
            }
          }
        });
    },
    prevStep() {
      if (--this.active <= 0) this.active = 0;

      if (this.active == 0) {
        this.approveId = this.tenantInformationId
          ? this.tenantInformationId
          : this.approveId;
        this.$refs["dataForm2"].clearValidate();
      }

      this.$router.push({
        name: "enterpriseBusinessRegister",
        query: { record: this.active, approveId: this.approveId },
      });
    },
    nextStep() {
      console.log(this.active);
      switch (this.active) {
        case 0:
          this.dataValid("dataForm1", this.addOrUpdateBaseInfo);
          if (JSON.stringify(this.info) !== "{}") {
            this.getBankInfo(this.info.approveRecordList[1].approveId);
          }
          break;
        case 1:
          if (
            this.dataForm2.welfareMerchantType != 2 &&
            this.dataForm2.isCollectionAccount != 1
          ) {
            console.log(this.dataForm2);
            this.dataValid("dataForm2", this.addOrUpdataRevice);
          } else if (
            this.dataForm2.welfareMerchantType == 2 &&
            this.dataForm2.isCollectionAccount != 1
          ) {
            this.$refs["dataForm2"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });
            this.$refs["chantTypeForm"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });
            if (this.flag) {
              this.chantTypeForm.employeesNumber =
                this.chantTypeForm.employeesNumber * 1;
              delete this.dataForm2.idCardPicBack;
              delete this.dataForm2.idCardPicFront;
              delete this.dataForm2.businessLicensePic;
              let param = {
                ...this.dataForm2,
                ...this.chantTypeForm,
              };
              this.addOrUpdataRevice(param);
            }
          } else if (
            this.dataForm2.welfareMerchantType == 2 &&
            this.dataForm2.isCollectionAccount == 1
          ) {
            this.$refs["dataForm2"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });
            this.$refs["chantTypeForm"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });
            this.$refs["clearForm"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });
              this.$refs["paymentForm"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });    
           
            if (this.flag) {
              this.chantTypeForm.employeesNumber =
                this.chantTypeForm.employeesNumber * 1;
              delete this.dataForm2.idCardPicBack;
              delete this.dataForm2.idCardPicFront;
              delete this.dataForm2.idCardPicFront;
              let param = {
                ...this.dataForm2,
                ...this.chantTypeForm,
                merchantSettleAccount: {
                  ...this.clearForm,
                },
                paymentAccount:{
                  ...this.paymentForm
                }
              };
              this.addOrUpdataRevice(param);
            }
          } else if (
            this.dataForm2.welfareMerchantType == 1 &&
            this.dataForm2.isCollectionAccount == 1
          ) {
            this.$refs["dataForm2"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });

            this.$refs["clearForm"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });
                this.$refs["paymentForm"].validate((valid) => {
              if (!valid) {
                this.flag = false;
                return false;
              }
              this.flag = true;
            });    
            if (this.flag) {
              delete this.dataForm2.idCardPicBack;
              delete this.dataForm2.idCardPicFront;
              delete this.dataForm2.idCardPicFront;
              let param = {
                ...this.dataForm2,

                merchantSettleAccount: {
                  ...this.clearForm,
                },
                  paymentAccount:{
                  ...this.paymentForm
                }
              };
          
           
              this.addOrUpdataRevice(param);
            }
          }

          break;
      }
    },
    dataValid(form, cb) {
      this.$refs[form].validate((valid) => {
        if (!valid) {
          this.flag = false;
          return false;
        }
        this.flag = true;
        let param = {
          ...this.dataForm2,
        };
        cb(param);
      });
    },

    //得到基本信息
    getBaseInfo(tenantInformationId) {
      this.$request
        .post(`/approver-api/api/web/approvetenantinformation/info`, {
          tenantInformationId,
        })
        .then((res) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm1 = {
            ...this.dataForm1,
            ...res.data,
            tenantCode: 666666,
          };
        });
    },
    //得到企业商户信息
    getBankInfo(enterpriseAccountId) {
      this.$request
        .post(
          `/approver-api/api/wemp/approveEnterpriseCollectionAccount/info`,
          {
            enterpriseAccountId: enterpriseAccountId,
          }
        )
        .then((res) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm2 = {
            ...this.dataForm2,
            ...res.data,
            tenantCode: 666666,
          };
          if(res.data.merchantSettleAccount&&res.data.merchantSettleAccount.length>0){
              this.clearForm = {
            accountName: res.data.merchantSettleAccount.accountName,
            accountBankName: res.data.merchantSettleAccount.accountBankName,
            accountBankNumber: res.data.accountBankNumber,
            rebate: res.data.merchantSettleAccount.rebate,
          };
          }
         
          this.chantTypeForm = {
            enterpriseName: res.data.enterpriseName,
            enterpriseNature: res.data.enterpriseNature,
            enterprisePhone: res.data.enterprisePhone,
            enterpriseAddress: res.data.enterpriseAddress,
            enterpriseRegionProvince: res.data.enterpriseRegionProvince,
            enterpriseRegionCity: res.data.enterpriseRegionCity,
            enterpriseRegion: res.data.enterpriseRegion,
            businessScope: res.data.businessScope,
            businessRegistrationNo: res.data.businessRegistrationNo,
            establishmentDate: res.data.establishmentDate,
            employeesNumber: res.data.employeesNumber,
            idCardPicFrontList: res.data.idCardPicFrontList,
            idCardPicBackList: res.data.idCardPicBackList,
            businessLicensePicList: res.data.businessLicensePicList,
            businessLicensePicUrlList:res.data.businessLicensePicUrlList,
            idCardPicBackUrlList:res.data.idCardPicBackUrlList,
            idCardPicFrontUrlList:res.data.idCardPicFrontUrlList,
          };
          if(res.data.paymentAccount&&res.data.paymentAccount.length>0){
             this.paymentForm = {
               rebate:res.data.paymentAccount.rebate,
              accountBankName: res.data.paymentAccount.accountBankName,
              accountBankNumber:res.data.paymentAccount.accountBankNumber,
              accountName: res.data.paymentAccount.accountName,
              companyNo:res.data.paymentAccount.companyNo,
              nodeNo: res.data.paymentAccount.nodeNo,
              openBankNumber: res.data.paymentAccount.openBankNumber,
              bizId: res.data.paymentAccount.bizId,
              operateType: 2,
              accountPeriod: res.data.paymentAccount.accountPeriod,
              payAgreementNumber:res.data.paymentAccount.payAgreementNumber
          }
          }
         
          this.dataForm2.operateType = 4;
          console.log(this.dataForm2)
          this.province();
          this.city();
          this.district();
        });
    },
    //增加或者修改基本信息
    addOrUpdateBaseInfo() {
      this.$refs["dataForm1"].validate((vaild) => {
        if (!vaild) {
          return false;
        }
        this.$request
          .post("/approver-api/api/web/approvetenantinformation/saveOrUpdate", {
            ...this.dataForm1,
          })
          .then((res) => {
            console.log(res);
            if (res.code !== 0) {
              return this.$message.error(res.msg);
            }
            this.dataForm2.tenantInformationId = res.data.tenantInformationId;
            this.tenantInformationId = res.data.tenantInformationId;
            console.log(this.tenantInformationId);
            sessionStorage.setItem(
              "tenantInformationId",
              res.data.tenantInformationId
            );
            if (++this.active >= 3) this.active = 3;
          });
      });
    },
    //增加或者修改企业商户账号信息
    addOrUpdataRevice(param) {
      this.$request
        .post(
          "/approver-api/api/wemp/approveEnterpriseCollectionAccount/saveOrUpdate",
          {
            ...param,
            tenantInformationId: this.tenantInformationId
              ? this.tenantInformationId
              : this.approveId,
          }
        )
        .then((res) => {
          console.log(res);
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.$router.push({
            name: "enterpriseBusinessRegister",
            query: { record: 2 },
          });
          // this.dataForm2.id = res.data.id;
          if (++this.active >= 3) this.active = 3;
          if (this.flag) {
            this.isCheck();
          }
        });
    },
    getImg1(val) {
      this.loading = false;
      this.chantTypeForm.idCardPicFrontList=[]
      this.chantTypeForm.idCardPicFrontList.push(val);
    },
    getLoading(data) {
      this.loading = data;
    },
    getImg2(val) {
      console.log(val);
      this.loading = false;
        this.chantTypeForm.idCardPicBackList=[]
      this.chantTypeForm.idCardPicBackList.push(val);
    },
    getImg3(val) {
      console.log(val);
      this.loading = false;
        this.chantTypeForm.businessLicensePicList=[]
      this.chantTypeForm.businessLicensePicList.push(val);
    },
    seeInfoHandle() {
      if (this.info.tanantState == 3) {
        this.active = 0;
        this.getBaseInfo(this.info.approveRecordList[0].approveId);
      } else {
        this.isCheck();
        setTimeout(() => {
          this.$router.push({
            name: "enterpriseBusinessInfo",
            query: {
              id:
                sessionStorage.getItem("enterpriseAccountId") || this.approveId,
            },
          });
        }, 200);
      }
    },
    backHandle() {
      this.$router.push({ name: "adminRegister" });
    },
  },
};
</script>
<style lang="less" scoped>
.el-form {
  h3 {
    padding-left: 50px;
    box-sizing: border-box;
    margin-top: 20px;
  }
}

.el-form-item {
  /deep/ .el-form-item__content {
    display: flex;
  }
}

.el-card {
  .el-steps {
    padding: 20px;
  }
  .stepBtn {
    text-align: center;
  }

  .text {
    position: absolute;
    font-size: 12px;
    color: #ccc;
    top: 10px;
    right: -90px;
  }
  .otherText {
    top: 20px;
    left: -100px;
  }
  .submitCheck {
    text-align: center;
    margin-top: 50px;
    .icon-style {
      color: green;
      display: block;
      font-size: 100px;
      margin: 0 auto;
    }
    p {
      margin-bottom: 70px;
    }
  }
  .card-contetn {
    min-height: 100vh;
  }
}

.avatar-uploader {
  border: 1px dashed #ccc;
  height: 60px;
  width: 80px;
  text-align: center;
  /deep/ .el-upload--text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>